import { render, staticRenderFns } from "./formAdd.vue?vue&type=template&id=e1b463c4&"
import script from "./formAdd.vue?vue&type=script&lang=js&"
export * from "./formAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports